import { GetImagesParams } from "./image.types";

export const IMAGE_KEYS = {
  all: ["images"] as const,
  lists: () => [...IMAGE_KEYS.all, "list"] as const,
  list: (params: any) => [...IMAGE_KEYS.lists(), params] as const,
  details: () => [...IMAGE_KEYS.all, "detail"] as const,
  detail: (id: string) => [...IMAGE_KEYS.details(), id] as const,
  myImages: (params?: GetImagesParams) =>
    [...IMAGE_KEYS.all, "my-images", params] as const,
};
